import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase.js';

import { PAGINATION, FILTER } from '../../../common/types/paginationType.js';
import global from '../../../common/utility/global.js';

import reporteCuentaCobrarService from '../../../service/tesoreria/reporteCuentaCobrarService.js';
import metodoPagoService from '../../../service/administracion/metodoPagoService.js';
import vendedorService from '../../../service/administracion/vendedorService';

import cuentaService from '../../../service/administracion/cuentaService.js';
import Header from "../../../components/Header.js";
import Filters from './Filters.js';
import ResultList from './ResultList.js';
import ResultListResumen from './ResultListResumen.js';
import ResultListDetalle from './ResultListDetalle.js';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            listaEstadoPago: [],
            metodoPagos: [],
            cuentas: [],
            vendedores: [],
            listaTipoComprobante: [],
            formaPagos: [],
            filter: {
                idTipoComprobante: 0,
                fechaInicioStr: global.fetchCurrentYearStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                cliente: '',
                idMetodoPago: 0,
                idCuenta: 0,
                idVendedor: 0,
                documento: '',
                tipoReporte: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false
        }
    }

    /********* PAGINATION ********/
    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: 0,
            fechaInicioStr: global.fetchCurrentYearStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            cliente: '',
            idMetodoPago: 0,
            idCuenta: 0,
            documento: '',
            tipoReporte: 0,
            idFormaPago: 0,
            idVendedor: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            this.ChangePaginationGetData();
        }
    };

    handleChange = async (property, value, texto, param) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter: filter });
        if (property == 'tipoReporte') {
            filter.page = 1;
            this._handlePagination(filter)
        }
    };


    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteCuentaCobrarService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined) {
            if (this.state.filter.tipoReporte == 0) {
                global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar General.xlsx");
            }
            if (this.state.filter.tipoReporte == 1) {
                global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar Resumen.xlsx");
            }
            if (this.state.filter.tipoReporte == 2) {
                global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar Detallado.xlsx");
            }
        }
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await reporteCuentaCobrarService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined) {
            if (this.state.filter.tipoReporte == 0) {
                global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar General.pdf");
            }
            if (this.state.filter.tipoReporte == 1) {
                global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar Resumen.pdf");
            }
            if (this.state.filter.tipoReporte == 2) {
                global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar Detallado.pdf");
            }
        }
    }



    /******************** FORM MODAL *****************/


    async componentDidMount() {

        const metodoPagos = await metodoPagoService.listar();
        const cuentaDestino = await cuentaService.listar_select();
        const vendedores = await vendedorService.listar();

        this._initPagination({ ...this.state.filter }, reporteCuentaCobrarService.paginacion);

        this.setState({
            loadingSource: false,
            metodoPagos: metodoPagos ? metodoPagos : [],
            cuentas: cuentaDestino ? cuentaDestino : [],
            vendedores: vendedores ? vendedores : [],
            listaEstadoPago: [],
            listaTipoComprobante: [{ 'id': 2, 'nombre': 'FACTURA' }, { 'id': 4, 'nombre': 'BOLETA' }, { 'id': 97, 'nombre': 'NOTA VENTA' }],
            formaPagos: [{ 'id': 1, 'nombre': 'CONTADO' }, { 'id': 2, 'nombre': 'CREDITO' }]
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Cuentas por Cobrar"
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estado={this.state.listaEstadoPago}
                    metodoPagos={this.state.metodoPagos}
                    cuentas={this.state.cuentas}
                    vendedores={this.state.vendedores}
                    listaTipoComprobante={this.state.listaTipoComprobante}
                    formaPagos={this.state.formaPagos}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                {(() => {
                    if (this.state.filter.tipoReporte == 0) {
                        return <ResultList
                            pagination={this.state.pagination}
                            loadingEdit={this.state.loadingSource}
                            loadingExcel={this.state.loadingExcel}
                            loadingPdf={this.state.loadingPdf}
                            loadingPrint={this.state.loadingPrint}
                            onExportExcel={this.handleExportExcel}
                            onExportPdf={this.handleExportPdf}
                            onChange={this._handleChangePagination}

                        />
                    }
                    return (
                        <div>
                            {this.state.filter.tipoReporte == 1 ?
                                <ResultListResumen
                                    pagination={this.state.pagination}
                                    loadingEdit={this.state.loadingSource}
                                    loadingExcel={this.state.loadingExcel}
                                    loadingPdf={this.state.loadingPdf}
                                    loadingPrint={this.state.loadingPrint}
                                    onExportExcel={this.handleExportExcel}
                                    onExportPdf={this.handleExportPdf}
                                    onChange={this._handleChangePagination}

                                />
                                :
                                <ResultListDetalle
                                    pagination={this.state.pagination}
                                    loadingEdit={this.state.loadingSource}
                                    loadingExcel={this.state.loadingExcel}
                                    loadingPdf={this.state.loadingPdf}
                                    loadingPrint={this.state.loadingPrint}
                                    onExportExcel={this.handleExportExcel}
                                    onExportPdf={this.handleExportPdf}
                                    onChange={this._handleChangePagination}

                                />
                            }
                        </div>
                    )
                })()}
            </div>
        );
    };
}